import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faLink} from '@fortawesome/pro-solid-svg-icons';
import {canCreateShareLinkPdfFromAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionCreatePDFShareIcon = faLink;

/**
 * Create pdf share link from asset
 * @param params
 * @returns Action
 */
export const assetActionCreatePDFShare = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-create-pdf-share-link',
	cb: () => dispatcher.trigger(ASSET_EVENT.CREATE_PDF_SHARE_LINK, asset),
	enableTest: () => canCreateShareLinkPdfFromAsset(asset),
	icon: assetActionCreatePDFShareIcon,
	get label() {
		return AssetActionLabel.CREATE_PDF_SHARE_LINK;
	},
	...params,
});

export default assetActionCreatePDFShare;
